<template>

<div>








<div class="grid">
<div class="col-12 md:col-6 py-0" v-if="!data.read_only_state">
<Listbox v-model="inputdata" :options="data.options"  :filter="true" optionLabel="name" optionValue="id" listStyle="max-height:250px" style="width:100%" filterPlaceholder="Search" @change="changed"  :disabled="nulled">
 <template #option="slotProps">
  {{ getTheTranslation(slotProps.option,"translation")}}
</template>
</Listbox>
</div>

<div class="col-12 md:col-6 py-0">
<template v-if="listfull.length">
<ScrollPanel style="width: 100%; height: 310px">
<div class="grid " v-for="item in listfull" :class="{ disabledlist: nulled }">

<div class="col-9 md:col-10">
<template v-if="nulled">
  <p class="p-text-secondary">{{getTheTranslation(item,"translation")}}</p>
</template>
<template v-else>
  <p class="p-text-secondary">{{getTheTranslation(item,"translation")}}</p>
</template>
</div>

<div class="col-3 md:col-2">
  <template v-if="nulled">
    <Button  icon="pi pi-trash"  class=" p-button-plain p-button-outlined  p-button-sm mt-3" :loading="$store.state.ui.submitting"/> 
  </template>
  <template v-else>
    <Button  v-if="!data.read_only_state" icon="pi pi-trash" @click="deleteOption(item.id)" class=" p-button-danger p-button-outlined  p-button-sm mt-3" :loading="$store.state.ui.submitting"/> 
  </template>

</div>

</div>
</ScrollPanel>
</template>
</div>

</div>








</div>

</template>

<script>
export default {

  name: 'ListselectType',
  props:["data"],

  data () {
    return {
    	inputdata:null,
    	intervalobj:null,
    	list:[],
    	listfull:[],
    }
  },
  mounted()
  {
    this.cleanDuplicates()
    this.listfull = []
  	if(this.data.submissions && this.data.submissions.length>0)
  	{
  		let list = JSON.parse(this.data.submissions[0].submission_text)
  		
      if(list && list.length)
      {
        this.list = list
        for(let item of list)
        {
          let index = this.data.options.findIndex((option)=>{return option.id == item})
          if(index!==-1)
          {
            this.listfull.push(this.data.options[index])
          }
          
        } 
      }
  		 		
  	}
  },
  watch:{
    propdata(newval)
    {
      this.inputdata = newval
    },
    data()
    {
      this.listfull = []
      if(this.data.submissions.length>0)
      {
        let list = JSON.parse(this.data.submissions[0].submission_text)
        
        if(list && list.length)
        { 
          this.list = list
          for(let item of list)
          {
            let index = this.data.options.findIndex((option)=>{return option.id == item})
            this.listfull.push(this.data.options[index])
          }  

        }
           
      }
    },
  },
  computed:{
    propdata()
    {
      if(this.data.submissions.length>0)
      {
        let propdata = this.data.submissions[0].submission_text
        return propdata
      }
    },
  	labeltext()
  	{
  		let translation = this.data.translations.find((item)=>{return item.language_id == this. $store.state.auth.user.preflang_id})
  		return translation.translation
  	},
  	helptext()
  	{
  		let translation = this.data.translations.find((item)=>{return item.language_id == this. $store.state.auth.user.preflang_id})
  		if(translation.description)
  		{
  			return translation.description
  		}
  		else
  		{
  			return ""
  		}
  	},
    nulled()
    {
      if(this.data.submissions.length && this.data.submissions[0].is_nulled)
      {
        return true
      }
      else
      {
        return false
      }
    }
  },
  methods: {
    cleanDuplicates()
    {
      let clean_list = []
      for(let item of this.data.options)
      {
        let ind = clean_list.findIndex(element=>element.name == item.name)
        {
          if(ind==-1)
            {
              clean_list.push(item)
            }
        }
      }
      this.data.options = clean_list

    },
  	changed(data)
  	{
      console.log("changed")
      console.log(data)
  		let ind = this.list.findIndex((item)=>{return item == data.value})
  		if(ind==-1)
  		{
  			this.list.push(data.value)
  			this.submitInputData()
  		}
  		
  	},
  	fieldChanged()
  	{
      this.$store.dispatch('evaluation/setActiveInputfield',this.data) 
  		clearInterval(this.intervalobj);
  		this.intervalobj = setInterval(()=>{
  			this.submitInputData()
  		},1000)
  	},
  	submitInputData()
  	{
  		clearInterval(this.intervalobj);
      if(!this.data.read_only_state)
      {
        let formdata = new FormData()
        formdata.append("text",JSON.stringify(this.list))
        formdata.append("type","listselect")
        formdata.append("flowsupplier_id",this.$store.state.evaluation.evaluation.uuid)
        this.generalSubmission(formdata,"audit/submit_inputfield_submission/"+this.data.id,this.afterListtypeSubmitted)
      }

  		
  	},
  	async afterListtypeSubmitted(response)
  	{
      console.log("afterListtypeSubmitted")
  		this.inputdata = await null
  		this.listfull = await []
  		for(let item of this.list)
  		{
  			let index = await this.data.options.findIndex((option)=>{return option.id == item})
  			
  			await this.listfull.push(this.data.options[index])
  		}
      await this.$store.dispatch('evaluation/setInputfieldsUpdating',true)
      await this.aftersubmitInputData(response)
      /*
      let inputfield = await this.checkSingleInputfieldCompletion(response.data)
      let all_ind = await this.$store.state.evaluation.inputfields.findIndex((item)=>{return item.id == inputfield.id})
      this.$store.state.evaluation.inputfields[all_ind] = await inputfield
      await this.calculateEvaluationProgress("first_init")
      */
  		
  	},
  	deleteOption(id)
  	{
      if(this.nulled)
      {
        return false
      }
  		this.list = this.list.filter((item)=>{return item !== id})
  		this.submitInputData()
  	},
  }
};
</script>

<style lang="css" scoped>
  .disabledlist{
    background-color: #e0e0e0;
  }
</style>